<template>
    <Modal :title="$t('management.accounts.add.modal.title')"
            @close="closeModal"
           :close-on-click-outside="false"
    >
        <template v-slot:body>
			<div class="modal-content">
				<BankForm @changeInfo="changeForm" :info="addAccountInfo"/>
				<template v-if="currentUser.companyTraderType === enumDef.traderType.Investor">
					<md-checkbox class="flex" v-model="addAccountInfo.buyAccount">
						{{ $t("management.accounts.check.isPortfolioAccount") }}
					</md-checkbox>
					<div class="text_left light_bg_color margin_top">
						<span class="font_bold">{{$t("common.hint")}}：</span>
						<br/>
						<span>{{$t("common.label.portfolioAccount.hint")}}</span>
					</div>
				</template>
			</div>
            <div class="flex flex_between margin_top">
                <md-button class="md-blank" @click="closeModal">
                    {{ $t("common.button.cancel") }}
                </md-button>
                <md-button class="opacity_5" :class="{ 'md-primary': submitBtnStatus }"
                           @click="addAccount"
                >
                    {{ $t('common.button.submit') }}
                </md-button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "@/components/templates/modal/Modal";
import BankForm from "@/components/templates/bankAccount/BankForm";
import {accountManagementApi} from "@/common/api/accountManagementApi";
import {enumDef} from "@/common/enumDefs";

export default {
    components: {
        Modal,
        BankForm
    },
    data() {
        return {
            addAccountInfo: {
                tag: "",
                iban: "",
                bic: "",
                currency: "",
                buyAccount: false
            },
			enumDef: enumDef
        };
    },
    computed: {
        submitBtnStatus() {
            return [
                "iban",
                "bic",
                "currency"
            ].every(key => this.addAccountInfo[key]);
        },
    },
    methods: {
        closeModal() {
            this.$emit("close");
        },
        changeForm(data) {
            const {
                mainAccountIban,
                tag,
                mainAccountBic,
                currency
            } = data;
            this.addAccountInfo.tag = tag;
            this.addAccountInfo.iban = mainAccountIban;
            this.addAccountInfo.bic = mainAccountBic;
            this.addAccountInfo.currency = currency;
        },
        addAccount() {
            if (!this.submitBtnStatus) {
                return;
            }

            accountManagementApi.operation.addAccount(this.addAccountInfo)
                .then(() => {
                   this.$emit("added");
                })
                .catch(e => {
                    this.toast(e);
                });
        },
    }
};
</script>